export class Format {
    public static readonly DATE = 'DD-MM-YYYY';
}